import { useTranslation } from "react-i18next";

const FEATURES = [
  { icon: "ri-time-line", title: "features.f1.title", text: "features.f1.text" },
  { icon: "ri-scales-3-line", title: "features.f2.title", text: "features.f2.text" },
  { icon: "ri-layout-grid-line", title: "features.f3.title", text: "features.f3.text" },
  { icon: "ri-lightbulb-line", title: "features.f4.title", text: "features.f4.text" },
];

export default function FeaturesSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-secondary-50">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-semibold uppercase tracking-wide text-accent-600">
            {t("features.eyebrow")}
          </span>
          <h2 className="mt-3 font-heading text-2xl font-semibold text-foreground-950 md:text-4xl">
            {t("features.title")}
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            {t("features.subtitle")}
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {FEATURES.map((feature) => (
            <div
              key={feature.title}
              className="rounded-lg border border-background-200 bg-background-50 p-6"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                <i className={`${feature.icon} text-2xl`} />
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
                {t(feature.title)}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{t(feature.text)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}